import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScript2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconScript2"><Path d="M14 18C14 19.3057 14.8355 20.413 16 20.8252V21H5C3.34315 21 2 19.6569 2 18V16H14V18Z" fill="currentColor"/><Path d="M17 19C17 19.5522 16.5254 20.0209 16.041 19.7559C15.4207 19.4163 15 18.7571 15 18V15H5V6C5 4.34315 6.34315 3 8 3H17.5039C17.1892 3.41817 17 3.93631 17 4.5V19Z" fill="currentColor"/><Path d="M19.5 3C20.3284 3 21 3.67157 21 4.5V9H18V4.5C18 3.67157 18.6716 3 19.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconScript2;
